import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import styled from 'styled-components';
import MuiChip from '@material-ui/core/Chip';

interface IChip {
  label: string;
  urlPath:
    | string
    | {
        pathname: string;
        query: { [key: string]: string };
      };
  shallow: boolean;
}

const CustomMuiChip = styled(MuiChip)`
  &.MuiChip-root {
    border-radius: 80px;
    color: ${props => props.theme.paletteDefault.primary.main};
  }
  & .MuiChip-label {
    padding: 8px 12px;
  }
`;

const IconWrapper = styled.div`
  &.MuiChip-deleteIcon {
    margin-right: 0;
    display: flex;
  }
`;

const Chip: React.FC<IChip> = ({ label, urlPath, shallow }) => {
  const router = useRouter();
  const onDeleteHandle = () => {
    router.push(urlPath, undefined, { shallow: shallow });
    return;
  };
  return (
    <CustomMuiChip
      variant="outlined"
      label={label}
      onDelete={onDeleteHandle}
      deleteIcon={
        <IconWrapper>
          <Image
            src="/asset/closeIcon.svg"
            alt={'close icon'}
            width={12}
            height={12}
            unoptimized={true}
          />
        </IconWrapper>
      }
    />
  );
};

export default Chip;
